module.exports = __webpack_public_path__ + "img/generic-function.335e8dcc.jpg";